import { delay } from '@utils/common';
import type { TFunction } from 'i18next';

export const getAccountName = (object: any, t: TFunction): string => {
  const subAccountName = object?.subAccount?.goal?.name;
  const accountType = object.subAccount?.account?.type
    ? t(`accountTypes:${object.subAccount.account.type}`)
    : object?.account?.type
      ? t(`accountTypes:${object.account.type}`)
      : undefined;

  if (!subAccountName && !accountType) return '-';
  return `${subAccountName || ''}${subAccountName && accountType ? ' - ' : ''}${accountType || ''}`;
};

export const encodeBase64 = (value: string) =>
  btoa(
    new TextEncoder()
      .encode(value)
      .reduce((data, byte) => data + String.fromCharCode(byte), ''),
  );

export const decodeBase64 = (encodedValue: string) =>
  new TextDecoder().decode(
    new Uint8Array(
      atob(encodedValue)
        .split('')
        .map((char) => char.charCodeAt(0)),
    ),
  );

export const scaledDelay = async ({
  magnitude,
  baseDelayMs = 3000,
  maxAdditionalDelayMs = 4000,
  threshold,
}: {
  magnitude: number;
  baseDelayMs?: number;
  maxAdditionalDelayMs?: number;
  threshold: number;
}) =>
  delay(
    baseDelayMs + Math.min(1.0, magnitude / threshold) * maxAdditionalDelayMs,
  );
